// extracted by mini-css-extract-plugin
export default {"asdfghjkl_asdfghjkl":"ActivitiesNotification_asdfghjkl_asdfghjkl__igeMD","AllNotifications_wrapper__":"ActivitiesNotification_AllNotifications_wrapper____3aHIE"};